import React from 'react';
import FavoriteButton from './FavoriteButton';

const NewsCard = ({ 
  item, 
  isFromToday, 
  isFromThisWeek, 
  type = 'insight', 
  storyKind,
  onClick,
  authUser
}) => {
  const effectiveStoryType = storyKind || item.story_type || type;
  const displayType = type || item.displayType || effectiveStoryType;

  const getTitle = () => {
    if (item.article?.title) return item.article.title;
    if (item.ai_takeaway_title) return item.ai_takeaway_title;
    if (displayType === 'local') return 'Local Energy Update';
    if (displayType === 'national') return 'National Energy Update';
    return effectiveStoryType === 'week' ? 'Weekly News Update' : 
           effectiveStoryType === 'day' ? 'Daily News Update' : 'Strategic Insight';
  };

  const getQueryBadge = () => {
    const fallbackLabel = displayType === 'local'
      ? 'Local Story'
      : displayType === 'national'
        ? 'National Story'
        : effectiveStoryType === 'week'
          ? 'Weekly Update'
          : effectiveStoryType === 'day'
            ? 'Daily News'
            : 'Strategic Analysis';
    const label = item.query_text || fallbackLabel;
    const className = displayType === 'local'
      ? 'insight-badge'
      : displayType === 'national'
        ? 'insight-badge'
        : effectiveStoryType === 'week'
          ? 'week-badge'
          : effectiveStoryType === 'day'
            ? 'day-badge'
            : 'insight-badge';
    return (
      <span className={`query-badge ${className}`}>
        {label}
      </span>
    );
  };

  const getSummary = () => {
    if (item.ai_summary) return item.ai_summary;
    if (item.article?.summary) return item.article.summary;
    if (displayType === 'local') {
      return 'Key developments affecting Arkansas cooperatives and communities.';
    }
    if (displayType === 'national') {
      return 'Broader industry intelligence impacting cooperative strategy.';
    }
    return effectiveStoryType === 'week' 
      ? 'Weekly news update for the electric cooperative industry.'
      : effectiveStoryType === 'day' 
      ? 'Latest daily news update for the electric cooperative industry.'
      : 'Key industry insight for electric cooperatives.';
  };

  return (
    <div 
      className={`news-card news-card-container ${onClick ? 'clickable-card' : ''}`}
      onClick={onClick}
      style={onClick ? { cursor: 'pointer' } : {}}
    >
      {item.article && (item.article.image || item.article?.query_photo_url || item.query_photo_url) && (
        <img 
          className="news-card-image"
          src={item.article.image || item.article?.query_photo_url || item.query_photo_url}
          alt={getTitle()}
        />
      )}
      <div className="p-4">
        <h5 className="news-card-title news-card-title-style">
          {getTitle()}
        </h5>
        {item.ai_takeaway_text && (
          <p className="news-card-takeaway news-card-takeaway-style">
            {item.ai_takeaway_text}
          </p>
        )}
        <p className="news-card-summary news-card-summary-style">
          {getSummary()}
        </p>
        {item.article && (
          <div className="news-card-meta news-card-meta-style">
            <div className="d-flex justify-content-between">
              <span>{item.article.source}</span>
              <span>{item.article.date ? new Date(item.article.date).toLocaleDateString() : ''}</span>
            </div>
          </div>
        )}
        <div className="news-card-badge-container mt-2">
          <div className="d-flex justify-content-between align-items-center">
            {getQueryBadge()}
            {item.article && (
              <FavoriteButton 
                articleId={item.article.id} 
                storyType={effectiveStoryType}
                authUser={authUser}
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewsCard;